export default {
  // Page title
  title: "Gestión de Bandeja",
  stationLetter: "Mensajes de Bandeja",
  autoConfig: "Configuración de Envío Automático",
  autoConfigMessage: "Registro de Mensajes de Envío Automático",

  // Search form
  recipient: "Cuenta de Miembro",
  recipientPlaceholder: "Ingrese cuenta de miembro",
  subject: "Asunto",
  subjectPlaceholder: "Ingrese asunto",
  status: "Estado",
  statusPlaceholder: "Seleccione estado",
  sendTime: "Hora de Operación",
  statisticsDate: "Fecha de Estadísticas",
  search: "Buscar",
  reset: "Restablecer",
  export: "Exportar",

  // Status
  unread: "No leído",
  read: "Leído",
  deleted: "Eliminado",

  // Task Status
  taskStatus: "Estado de la Tarea",
  statusNotSent: "No enviado",
  statusSending: "Enviando",
  statusSent: "Enviado",

  // Operation
  operationTime: "Hora de Operación",
  operator: "Operador",
  agentMembers: "Miembros del Agente",
  startTime: "Hora de Inicio",
  endTime: "Hora de Fin",
  memberType: "Tipo de Miembro",
  currency: "Moneda",

  // Table columns
  content: "Contenido",
  language: "Idioma",
  receiveTime: "Hora de Recepción",
  sender: "Operador",
  messageType: "Tipo de Mensaje",

  // Messages
  exporting: "Exportando...",
  exportSuccess: "Exportación exitosa",
  exportFailed: "Exportación fallida",
  operationFailed: "Operación fallida",
  requestFailed: "Solicitud fallida",

  // Other
  seeDetails: "Ver",

  // Send message modal
  sendMessage: "Enviar Mensaje de Bandeja",
  language_label: "Seleccionar Idioma:",
  recipient_label: "Cuenta de Miembro",
  currency_label: "Moneda del usuario:",
  designatedMembers: "Miembros Designados",
  allMembers: "Todos los Miembros",
  agent: "Agente bajo miembros",
  designatedVipMembers: "Miembros VIP Designados",
  directCustomers: "Clientes Directos",
  importUsernames: "Importar Nombres de Usuario",
  agentLabel: "Agente:",
  selectAgent: "Seleccionar agente",
  vipLevelLabel: "Nivel VIP:",
  selectVipLevel: "Seleccionar nivel VIP",
  membersLabel: "Seleccionar Miembros:",
  memberPlaceholder: "Buscar y seleccionar miembros",
  membersRequired: "Por favor seleccionar miembros",
  usernamesLabel: "Importar Nombres de Usuario:",
  usernamesPlaceholder: "Ingrese nombres de usuario, múltiples separados por coma o nueva línea",
  usernamesRequired: "Por favor ingrese o importe nombres de usuario",
  titleLabel: "Asunto:",
  titlePlaceholder: "Dentro de 50 caracteres",
  titleRequired: "Por favor ingrese asunto",
  summaryLabel: "Resumen",
  summaryPlaceholder: "Ingrese resumen, hasta 200 caracteres",
  coverImageLabel: "Imagen de Portada",
  titleMaxLength: "El asunto no debe exceder 50 caracteres",
  contentLabel: "Contenido:",
  contentRequired: "Por favor ingrese contenido",
  contentMaxLength: "El contenido no debe exceder 1000 caracteres",
  contentCharLimit: "Límite de caracteres de contenido: 1000",
  sendSuccess: "Envío exitoso",
  sendFailed: "Envío fallido",

  // Status options
  statusUnread: "No leído",
  statusRead: "Leído",
  statusDeleted: "Eliminado",

  // Target user count
  targetUsers: "Usuarios Objetivo",
  downloadTemplate: "Descargar Plantilla",

  // Message type
  messageType_label: "Tipo de Mensaje:",
  messageType_system: "Mensaje del Sistema",
  messageType_promos: "Mensaje Promocional",
  messageType_updates: "Mensaje de Plataforma",

  // Auto-send configuration
  autoConfigTitle: "Agregar Plantilla de Envío Automático",
  autoConfigTitle_edit: "Editar Plantilla de Envío Automático",
  templateName_label: "*Título de la plantilla:",
  templateName_placeholder: "Máximo 50 caracteres",
  templateName_required: "Ingrese el título de la plantilla",
  templateName_maxLength: "El título de la plantilla no puede exceder 50 caracteres",
  templateCode_label: "Tipo de Objetivo:",
  templateCode_placeholder: "Seleccionar tipo de objetivo",
  templateCode_required: "Por favor seleccionar tipo de objetivo",
  registerUsers: "Usuarios Nuevos Registrados",
  firstRechargeUsers: "Usuarios de Primera Recarga",
  title_label: "Título:",
  title_placeholder: "Dentro de 50 caracteres",
  title_required: "Por favor ingrese título",
  title_maxLength: "El título no debe exceder 50 caracteres",
  recipient_type_label: "Cuenta de Miembro:",
  allMembers_label: "Todos los Miembros",
  agent_label: "Agente",
  agent_select_label: "Agente:",
  agent_placeholder: "Seleccionar agente",
  agent_required: "Por favor seleccionar agente",
  messageType_type_label: "Tipo de Mensaje:",
  messageType_placeholder: "Seleccionar tipo de mensaje",
  messageType_required: "Por favor seleccionar tipo de mensaje",
  content_label: "Contenido:",
  content_required: "Por favor ingrese contenido",
  content_maxLength: "El contenido no debe exceder 1000 caracteres",
  autoConfig_search: "Buscar",
  autoConfig_reset: "Restablecer",
  autoConfig_add: "Agregar",
  autoConfig_edit: "Editar",
  autoConfig_enable: "Habilitar",
  autoConfig_delete: "Eliminar",
  autoConfig_templateName: "Título de Plantilla",
  autoConfig_currency: "Moneda",
  autoConfig_targetType: "Tipo de Objetivo",
  autoConfig_status: "Estado",
  autoConfig_language: "Idioma",
  autoConfig_content: "Contenido",
  autoConfig_operator: "Operador",
  autoConfig_actions: "Acciones",
  autoConfig_disabled: "Deshabilitado",
  autoConfig_enabled: "Habilitado",
  autoConfig_disable: "Deshabilitar",
  autoConfig_all: "Todos",
  autoConfig_enableSuccess: "Habilitado exitosamente",
  autoConfig_disableSuccess: "Deshabilitado exitosamente",
  autoConfig_deleteSuccess: "Eliminado exitosamente",
  autoConfig_deleteFailed: "Error al eliminar",
  autoConfig_operationFailed: "Operación fallida",
  autoConfig_editSuccess: "Actualizado exitosamente",
  autoConfig_editFailed: "Error al actualizar",
  autoConfig_createSuccess: "Creado exitosamente",
  autoConfig_createFailed: "Error al crear",

  // Placeholder related
  placeholder_availablePlaceholders: "Marcadores de Posición Disponibles",
  placeholder_noPlaceholders: "Sin marcadores de posición disponibles",
  placeholder_example: "Ejemplo",
  placeholder_insertToTitle: "Insertar en Título",
  placeholder_insertToContent: "Insertar en Contenido",
  placeholder_tip: "Consejo: Haga clic en el marcador de posición para copiar, pase el ratón para ver detalles y opciones de inserción",
  placeholder_copied: "Copiado al portapapeles",
  placeholder_copyFailed: "Error al copiar",
  placeholder: {
    memberAccount_desc: "Cuenta de Miembro",
    currency_desc: "Moneda"
  },

  // Statistics page
  stats_serialNumber: "Número de Serie",
  stats_targetType: "Tipo de Objetivo",
  stats_memberType: "Tipo de Miembro",
  stats_statisticsTime: "Hora de Estadísticas",
  stats_received: "Recibido",
  stats_readCount: "Recuento de Leídos",
  stats_unreadCount: "Recuento de No Leídos",
  stats_readRate: "Tasa de Lectura",
  startDate: "Fecha de Inicio",
  endDate: "Fecha de Fin"
};
